import getApiHost from '@/services/utils/get-api-host'

const apiHost = getApiHost()

export default {
  apiHost,
  fileUploadUrl: `${apiHost}/api/private/v1/upload-file`,
  mediaUploadUrl: `${apiHost}/api/private/v1/media`,
  documentUploadUrl: `${apiHost}/api/private/v1/media/documents`,
  googleSignIn: `${apiHost}/api/private/v1/auth/login/google`,
  googleRecaptchaSitekey: import.meta.env.VITE_GOOGLE_RECAPTCHA_SITEKEY ?? '',
  pixelUrl: import.meta.env.VITE_APP_PIXEL_URL ?? '',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? '',
  authTokenKey: 'auth_token_default',
  rememberUserCookieKey: 'rememberUser'
}
